module.exports = __webpack_public_path__ + "img/no-photo.4507c7fe.png";